import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TuiButtonModule } from "@taiga-ui/core";
import { KwikUIButtonComponent } from "./button.component";

@NgModule({
  declarations: [KwikUIButtonComponent],
  imports: [CommonModule, TuiButtonModule],
  exports: [KwikUIButtonComponent]
})
export class KwikUIButtonModule {}
